import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyMyStay = loadable(() => import(/* webpackChunkName: "content/my-stay" */ '.'), 'MyStay');
